export default __webpack_public_path__ + "static/char-s-sp03-zh-Hans-3c4d7cf7277f0392c3a43bef8025c585.webp";